<template>
    <panel v-if="isNipEmployee"
        :panel="this.panel" />
</template>

<script>
    import Panel from '../Panel';

    export default {
        props: {
            panel: Object
        },
        components: {
            Panel
        },
        computed: {
            isNipEmployee() {
                return this.$store.getters.claims.nijEmployee.read;
            }
        }
    }
</script>
